import { useState } from "react";
import { Plus } from "lucide-react";
import client, { getErrorMessage } from "@/api/client";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";

// Inline "Add new" shortcut for the Service Type / Grade dropdowns.
export default function AddMasterInline({ kind, noun, onAdded, testId }) {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!name.trim()) return toast.error(`${noun} name is required`);
    setBusy(true);
    try {
      const res = await client.post(`/configurations/${kind}`, { name: name.trim() });
      toast.success(`${noun} added`);
      setOpen(false);
      setName("");
      onAdded(res.data);
    } catch (err) {
      toast.error(getErrorMessage(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Button type="button" variant="outline" size="icon" className="h-9 w-9 shrink-0" title={`Add new ${noun}`} data-testid={testId} onClick={() => setOpen(true)}>
        <Plus className="h-4 w-4" />
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm" data-testid={`${testId}-dialog`}>
          <DialogHeader><DialogTitle>Add new {noun}</DialogTitle></DialogHeader>
          <form onSubmit={submit} className="space-y-4">
            <Input autoFocus placeholder={`${noun} name`} value={name} onChange={(e) => setName(e.target.value)} data-testid={`${testId}-name-input`} />
            <DialogFooter>
              <Button type="button" variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
              <Button type="submit" disabled={busy} className="bg-amber-600 hover:bg-amber-700" data-testid={`${testId}-save`}>Add</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
}
